export default "__VITE_ASSET__t6ZG4aNV__"